export type HardwareOrderFulfillmentStatus = 'awaiting' | 'partial' | 'fulfilled' | 'cancelled';

export interface HardwareOrderItem {
  id: string;
  hardware_order_id: string;
  shopify_line_item_id: string | null;
  sku: string | null;
  title: string | null;
  quantity: number;
  product_id: string | null; // resolved stock_products match; null = unmatched SKU
  unit_price_cents: number;
}

export interface HardwareOrder {
  id: string;
  shopify_order_id: string;
  shopify_order_number: string | null;
  email: string | null;
  user_id: string | null; // linked platform user (best-effort by email at ingest)
  currency: string | null;
  total_cents: number;
  financial_status: string | null;
  fulfillment_status: HardwareOrderFulfillmentStatus;
  raw_payload: unknown; // full Shopify order object — all detail available
  created_at: string;
  updated_at: string;
  items?: HardwareOrderItem[];
}

export const FULFILLMENT_LABELS: Record<HardwareOrderFulfillmentStatus, string> = {
  awaiting: 'Awaiting',
  partial: 'Partial',
  fulfilled: 'Fulfilled',
  cancelled: 'Cancelled',
};

export const FULFILLMENT_COLORS: Record<HardwareOrderFulfillmentStatus, string> = {
  awaiting: 'bg-amber-500/20 text-amber-400',
  partial: 'bg-blue-500/20 text-blue-400',
  fulfilled: 'bg-green-500/20 text-green-400',
  cancelled: 'bg-slate-500/20 text-slate-400',
};

export const ALL_FULFILLMENT_STATUSES: HardwareOrderFulfillmentStatus[] = ['awaiting', 'partial', 'fulfilled', 'cancelled'];

// Shopify prices are decimal strings in major units; we store integer cents.
export function formatMoney(cents: number, currency: string | null): string {
  const amount = (cents / 100).toFixed(2);
  return currency ? `${amount} ${currency}` : amount;
}
